import { render, staticRenderFns } from "./QuestDoctor.vue?vue&type=template&id=bde3affc&scoped=true&"
import script from "./QuestDoctor.ts?vue&type=script&lang=ts&"
export * from "./QuestDoctor.ts?vue&type=script&lang=ts&"
import style0 from "./QuestDoctor.scss?vue&type=style&index=0&id=bde3affc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde3affc",
  null
  
)

export default component.exports